<template>
  <div class="main">
    <div
      class="list-main"
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="scrollDisabled"
      infinite-scroll-immediate-check="false"
    >
      <div class="order-list-mian">
        <div
          class="order-list-item"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="item-top">
            <span class="t-txt">订单编号：{{ item.PlatformOrderID }}</span>
            <span class="t-type-txt">已退款</span>
          </div>
          <!-- main -->
          <div class="item-nav">
            <div class="item-mian">
              <div class="m-img"><img :src="item.PicUrl" /></div>
              <div class="m-right">
                <div class="mr-item">
                  <div class="txt">
                    <plat-formLogo
                      :shopType="$utils.shopTypeNumChangeToText(item.ShopType)"
                    ></plat-formLogo>
                    <template>{{ item.TitleShort || "----" }}</template>
                  </div>
                </div>
                <div class="mr-item">
                  <div class="mp price">
                    ￥{{ (item.PayPrice - item.BuyRebatePrice) | formatFloat }}
                  </div>
                  <div class="mp discount-price">
                    ￥{{ item.PayPrice | formatFloat }}
                  </div>
                  <div class="tr align_left">×1</div>
                </div>
              </div>
            </div>
            <div class="bottomControlPart">
              <van-popover
                v-model="item.showPopover"
                trigger="click"
                placement="bottom-start"
                :actions="actions"
                :overlay="true"
                @select="onSelect"
                @open="onOpen(item)"
              >
                <template #reference>
                  <div class="more">更多操作</div>
                </template>
              </van-popover>
              <div class="item-price" v-if="item.SOStatus !== 0">
                预计返利：
                <span class="price"
                  >￥{{ item.BuyRebatePrice | formatFloat }}</span
                >
              </div>
            </div>
            <!-- <div class='item-price' v-if="item.SOStatus!== 0">预计返利：
                <span class='price'>￥{{item.BuyRebatePrice | formatFloat}}</span>
              </div> -->
          </div>
        </div>
      </div>
      <segement-Line v-if="!haveMore" line-text="没有更多订单了">
      </segement-Line>
      <segement-Line v-else :is-load="true"> </segement-Line>
    </div>
  </div>
</template>

<script>
import orderHandler from "@/mixins/orderHandler";
import SegementLine from "@/components/puppetComponent/SegementLine";
// import OrderItem from '@/components/smartComponent/OrderItem'
import { Indicator, Toast } from "mint-ui";
import { SaleTaskRefundList } from "@/api/my";
import { Popover } from "vant";
export default {
   mixins: [orderHandler],
  data() {
    return {
      haveMore: true,
      scrollDisabled: false,
      dataList: [],
      currentPage: 1,
      page: 1,
      pageCount: 1,
      actions: [{ text: "删除订单" }],
      currentItem: null
    };
  },
  components: {
    SegementLine,
    "van-popover": Popover,
    // OrderItem
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      Indicator.open({
        text: "加载中",
        spinnerType: "triple-bounce",
      });
      let params = { page: this.currentPage };
      this.scrollDisabled = true;
      SaleTaskRefundList(params)
        .then((res) => {
          Indicator.close();
          this.dataList = [...this.dataList, ...res.DataList];
          this.page = res.PaginationViewModel.Page;
          this.pageCount = res.PaginationViewModel.PageCount;
          if (
            res.PaginationViewModel.Page >= res.PaginationViewModel.PageCount
          ) {
            this.haveMore = false;
          }
          this.scrollDisabled = false;
        })
        .catch((res) => {
          this.haveMore = false;
          Indicator.close();
          if (res.ErrMsg) {
            Toast(res.ErrMsg);
          }
        });
    },
    loadMore() {
      let { page, pageCount } = this;
      if (page >= pageCount) {
        this.haveMore = false;
        return;
      }
      this.currentPage += 1;
      this.haveMore = true;
      this.fetchData();
    },
    onSelect(action) {
      switch (action.text) {
        case '我要投诉':
          // this.toComplaint(this.currentItem.ProductID, this.currentItem.TaskID)
          this.$toast('我要投诉')
          break;
        // 删除订单
        default:
          // this.$emit("deleteOrder", this.currentItem.TaskID);
          this.deleteOrder(this.currentItem.TaskID)
          break;
      } 
    },
    onOpen(item) {
      this.currentItem = item
    }
  },
  filters: {
    formatFloat(val) {
      if (!val) {
        val = 0;
      }
      return Number(val).toFixed(2);
    },
  },
};
</script>

<style scoped>
@import "../orderItem.css";
</style>
